export const ClockIcon = () => (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Z"
            stroke="#7F8898"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8 4.667V8l1.333 2"
            stroke="#7F8898"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
